import * as THREE from 'three';

/**
   * Returns an array of points that form a circle in 3D space.
   *
   * @param {Object} center - The center point of the circle.
   * @param {number} radius - The radius of the circle.
   * @param {number} nPoints - The number of points to generate on the circle.
   * @returns {THREE.Vector3[]} An array of points that form a circle in 3D space.
   */
export const makeCircleGetPoints = (center, radius, nPoints) => {
  const points = [];
  for (let i=0; i<nPoints; i++) {
    const angle = 2*Math.PI/nPoints*i;
    const x = center.x + radius * Math.cos(angle);
    const y = center.y;
    const z = center.z + radius * Math.sin(angle);
    points.push(new THREE.Vector3(x, y, z));
  }
  return points;
}